import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../component/Header';
import Footer from '../component/Footer';
import BottomNav from '../component/BottomNav';
import { Box } from '@mui/material';

const Layout = () => {
    return (
        <>
            <Header />


            <Box component="main" sx={{ flexGrow: 1, bgcolor: '#F8F9FA' }}>
                <Outlet />
            </Box>
            <Footer />
            <BottomNav />
        </>
    );
};

export default Layout;